<template>
    <div>
        <!-- <div class="switch_div">
            <div class="switch_btn" :class="{'action':action_name == 'day'}" @click="switchFun('day')">按日查看</div>
            <div class="switch_btn" :class="{'action':action_name == 'month'}" @click="switchFun('month')">按月查看</div>
        </div>
        <div class="date_div">
            <van-cell
             is-link 
             @click="showPopup"
             :value="timeValue"
            ></van-cell>
            <van-popup v-model="show" position="bottom">
                <van-datetime-picker
                v-model="currentDate"
                :type="popupData"
                title="选择年月日"
                :min-date="minDate"
                :max-date="maxDate"
                @confirm="confirmPickerFun"
                @cancel="cancelPickerFun"
                />
            </van-popup>
        </div> -->
        <List 
            :text="text" 
            :notText="notText"
            :list="list"
        />
    </div>
</template>

<script>
import List from '@/components/list.vue'
// import Vue from 'vue';
// import { DatetimePicker,Popup,Cell } from 'vant';
import autho from '../autho/autho.js';

var that;
// Vue.use(Popup);
// Vue.use(DatetimePicker);

export default {
    data(){
        return {
            show: false,//vant弹出框字段
            minDate: null,//时间选择器最小时间
            maxDate: null,//时间选择器最大时间
            currentDate: new Date(),//时间选择器当前时间
            timeValue:'请选择时间',//选择时间初始显示状态
            text:'您暂无记录哦!',//加载数据没有内容显示文字
            record:false,//加载数据没有时是否显示无记录框
            action_name:'day',//切换按钮的当前状态
            popupData:'date',//时间器的类型，（年月日/年月）
            accountCode:null,//账户码
            hasNextPage:false,//页码数
            list:[],//页面列表
            page:1,//初始
            notText:false,//当没有数据显示提示语-状态
            day_obj:{//日数据初始化
                day_check:true,
                degrees:null,
                useTime:null,
                endDegrees:null,
                dayDate:null,//选择了日时间器时间初始化
            },
            month_obj:{//月数据初始化
                month_check:false,
                month_amount:null,
                month_time:null,
                monthDate:null,//选择了月时间器时间初始化
            }
        }
    },
    components:{
        // vanCell:Cell,
        List
    },
    beforeCreate(){
        document.querySelector('body').style.background = '#f6f6f6'
    },
    activated(){
        that = this;
        let _year = new Date();
        let min_year = _year.getFullYear() - 10;
        let max_year = _year.getFullYear() + 10;
        that.minDate = new Date(min_year,0,1);
        that.maxDate = new Date(max_year,11,31);
        that.accountCode = that.$route.query.accountCode;
        that.currentDate = _year;
        that.timeValue = '请选择时间';
        that.action_name = 'day';
        that.popupData = 'date';
        that.record = false;
        that.month_obj.monthDate = null;
        that.day_obj.dayDate = null;
        that.list = [];
        // that.requestFun(that.accountCode,that.getThatDate('day'))
        that.page = 1;
        that.runningWaterFun(that.accountCode,that.page)
        window.addEventListener('scroll', that.handleScroll)
    },
    deactivated(){
        window.removeEventListener('scroll', that.handleScroll)
    },
    methods:{
        // 时间转换
        timeChange(msg){
            let date = new Date(msg)
            var YY = date.getFullYear() + '/';
            var MM = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '/';
            var DD = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ' ';
            var hh = (date.getHours()<10 ? '0'+date.getHours() : date.getHours()) + ':';
            var mm = (date.getMinutes()<10 ? '0'+date.getMinutes() : date.getMinutes());
            return YY+MM+DD+hh+mm
        },
        // 流水账单
        async runningWaterFun(accountCode,page){
            const res = await autho.request('token','post','/gzhWxApiController/getDeviceDeductionMonth',{
                    accountCode:accountCode,
                    page:page
                })
            autho.resetDataFun(res,function(){
                let _data = res.data.data;
                that.hasNextPage = _data.hasNextPage;
                if(_data.list.length > 0){
                    for(var i=0;i<_data.list.length;i++){
                        let _iTime_start = _data.list[i].start_reading_time;
                        let new_iTime_start = _iTime_start.replace(/-/g,'/');
                        let _iTime_end = _data.list[i].end_reading_time;
                        let new_iTime_end = _iTime_end.replace(/-/g,'/');
                        _data.list[i].start_reading_time = that.timeChange(new_iTime_start)
                        _data.list[i].end_reading_time = that.timeChange(new_iTime_end)
                    }
                    that.list = that.list.concat(_data.list);
                }else{
                    that.notText = true
                }
            })
        },
        //加载更多
        handleScroll(){
            var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
            if(scrollTop + windowHeight > scrollHeight - 240){
                if(that.hasNextPage == true){
                    that.hasNextPage = false;
                    that.page++;
                    that.runningWaterFun(that.accountCode,that.page)
                }
            }
        },
        // 日 数据
        async requestFun(accountCode,time){
            const res = await autho.request('token','post','/gzhWxApiController/getDeviceDeductionDay',{
                    accountCode:accountCode,
                    date:time
                })
            autho.resetDataFun(res,function(){
                let _data = res.data.data;
                if(_data == null){
                    that.record = true;
                    that.day_obj.day_check = false;
                    that.month_obj.month_check = false;
                }else{
                    that.record = false;
                    that.day_obj.day_check = true;
                    that.month_obj.month_check = false;
                    that.day_obj.degrees = _data.degrees;
                    that.day_obj.useTime = _data.useTime;
                    that.day_obj.endDegrees = _data.endDegrees;
                }
            })
        },
        // 月 数据
        async requestMonthFun(accountCode,time){
            const res = await autho.request('token','post','/gzhWxApiController/getDeviceDeductionMonth',{
                    accountCode:accountCode,
                    date:time
                })
            autho.resetDataFun(res,function(){
                let _data = res.data.data;
                that.check = false;
                if(_data == null){
                    that.record = true;
                    that.day_obj.day_check = false;
                    that.month_obj.month_check = false;
                }else{
                    that.record = false;
                    that.day_obj.day_check = false;
                    that.month_obj.month_check = true;
                    that.month_obj.month_amount = _data.degrees;
                    that.month_obj.month_time = _data.useTime;
                }
            })
        },
        // vant弹出框
        showPopup() {
            if(that.action_name == 'day'){
                that.popupData = 'date'
            }else if(that.action_name == 'month'){
                that.popupData = 'year-month'
            }
            that.show = true;
        },
        // 选择时间确定
        confirmPickerFun(val){
            let year = val.getFullYear()
            let month = val.getMonth() + 1
            let day = val.getDate()
            if (month >= 1 && month <= 9) { month = `0${month}` }
            if (day >= 1 && day <= 9) { day = `0${day}` }
            that.show = false
            if(that.action_name == 'day'){
                that.timeValue = `${year}-${month}-${day}`;
                that.day_obj.dayDate = `${year}-${month}-${day}`;
                that.requestFun(that.accountCode,that.timeValue)
            }else if(that.action_name == 'month'){
                that.timeValue = `${year}-${month}`;
                that.month_obj.monthDate = `${year}-${month}`;
                that.requestMonthFun(that.accountCode,that.timeValue)
            }
        },
        // 选择时间取消
        cancelPickerFun(){
            that.show = false
        },
        // 日、月查看切换
        switchFun(val){
            that.action_name = val;
            if(val == 'day'){
                if(that.day_obj.dayDate){
                    that.timeValue = that.day_obj.dayDate;
                    that.requestFun(that.accountCode,that.day_obj.dayDate)
                }else{
                    that.timeValue = '请选择时间'
                    that.requestFun(that.accountCode,that.getThatDate('day'))
                }
            }else if(val == 'month'){
                if(that.month_obj.monthDate){
                    that.timeValue = that.month_obj.monthDate
                    that.requestMonthFun(that.accountCode,that.month_obj.monthDate)
                }else{
                    that.timeValue = '请选择时间'
                    that.requestMonthFun(that.accountCode,that.getThatDate('month'))
                }
            }
        },
        // 当前时间
        getThatDate(val){
            let nowDate = new Date()
            let date = {
                year: nowDate.getFullYear()
            }
            if(nowDate.getMonth()+1 < 10){
                date.month = `0${nowDate.getMonth()+1}`
            }else{
                date.month = nowDate.getMonth()+1
            }
            if(nowDate.getDate() < 10){
                date.date = `0${nowDate.getDate()}`
            }else{
                date.date = nowDate.getDate()
            }
            if(val == 'day'){
                return date.year + '-' + date.month + '-' + date.date
            }else if(val == 'month'){
                return date.year + '-' + date.month
            }
        }
    }
}
</script>



<style scoped>
.switch_div {
    width: 2.5rem;
    height: 0.4rem;
    display: flex;
    background: #e1e1e1;
    border-radius: 0.05rem;
    margin: 0.1rem auto;
}
.switch_btn {
    width: 1.25rem;
    height: 0.4rem;
    background: #e1e1e1;
    border-radius: 0.05rem;
    font-size: 0.12rem;
    text-align: center;
    line-height: 0.4rem;
    color: #828282;
}
.switch_btn.action {
    color: #607da4;
    background: #fff;
    box-shadow: 0px 0px 3px 0px #bab9b9;
}
.date_div {
    height: 0.4rem;
    background: #fff;
    padding: 0 0.1rem;
    display: flex;
    align-items: center;
    font-size: 0.12rem;
    color: #607da4;
}
.date_div select {
    border: none;
    outline: none;
    font-size: 0.12rem;
    color: #607da4;
}
</style>